import React from 'react';
import { componentService } from 'js/services/component.service';

export const Deposit = React.lazy(() => import(/* webpackChunkName: "cashier" */ './Cashier').then((module) => ({ default: module.Deposit })));
export const Withdrawal = React.lazy(() => import(/* webpackChunkName: "cashier" */ './Cashier').then((module) => ({ default: module.Withdrawal })));

componentService.registerPageComponents({ Deposit, Withdrawal });
